import { FETCH_MENU_KEY, TOGGLE_DRAWER_MENU } from "../actionTypes";

const fetchMenuAction = (menuParentKey, menuKey) => ({
	type: FETCH_MENU_KEY,
	menuParentKey,
	menuKey
})

const toggleDrawerMenuAction = () => ({
	type: TOGGLE_DRAWER_MENU
})

export {
	fetchMenuAction,
	toggleDrawerMenuAction
}


// WEBPACK FOOTER //
// ./src/store/actions/leftSideMenu.js